import { Spinner } from 'react-bootstrap';

const LoadingScreen = () => {
  return (
    <div className="text-center py-4">
      <Spinner animation="border " role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default LoadingScreen;
